import { createFileRoute } from '@tanstack/react-router';
import { InvoiceSummaryStats } from '~/components/invoice-summary-stats';
import { InvoiceTable } from '~/components/invoice-table';

export const Route = createFileRoute('/_authenticated/facturen')({
    component: FacturenPage,
});

function FacturenPage() {
    return (
        <div className="flex flex-col gap-4 p-6">
            <h1 className="text-[20px] font-bold text-[#202020]">Facturen</h1>
            <InvoiceSummaryStats />
            <InvoiceTable />
        </div>
    );
}
